<template>
  <div class="p-grid dashboard">
    <div class="p-col-12">
      <Toast />

      <div class="card">
        <h5>
          <b>Daftar Kategori</b>
        </h5>
        <Toolbar class="p-mb-4">
          <template slot="left">
            <Button
              label="Tambah"
              icon="pi pi-plus"
              class="p-button-success p-mr-2"
              @click="createCategory()"
            />
          </template>

          <template slot="right"> </template>
        </Toolbar>

        <DataTable
          :value="categories"
          :paginator="true"
          :rows="10"
          :loading="loading.filter"
        >
          <template #header>
            <div
              class="p-grid p-fluid p-mb-2"
              v-if="$store.state.user.role === 'WAREHOUSE_MANAGER'"
            >
              <div class="p-col">
                <InputText v-model="filter.code" placeholder="Kode Kategori" />
              </div>
              <div class="p-col">
                <InputText v-model="filter.name" placeholder="Nama Kategori" />
              </div>
              <div class="p-col-12 p-md-4 p-lg-4">
                <Button
                  label="Cari"
                  class="p-button-info"
                  @click="getCategories()"
                  v-shortkey="['enter']"
                  @shortkey="getCategories()"
                />
              </div>
            </div>
          </template>

          <template #empty>Tidak ada kategori.</template>
          <template #loading>Loading data kategori. Mohon tunggu.</template>

          <Column field="code" header="Kode">
            <template #body="slotProps">
              {{ slotProps.data.code }}
            </template>
          </Column>
          <Column field="name" header="Nama">
            <template #body="slotProps">
              {{ slotProps.data.name }}
            </template>
          </Column>

          <Column header="Kelompok Kategori">
            <template #body="slotProps">
              {{ slotProps.data.parent ? slotProps.data.parent : '-' }}
            </template>
          </Column>

          <Column>
            <template #body="slotProps">
              <router-link
                :to="{
                  name: 'category-detail',
                  query: { id: slotProps.data.id }
                }"
              >
                <Button icon="pi pi-eye" class="p-button-rounded p-mr-2" />
              </router-link>

              <router-link
                :to="{
                  name: 'category-edit',
                  query: { id: slotProps.data.id }
                }"
              >
                <Button
                  icon="pi pi-pencil"
                  class="p-button-rounded p-button-success p-mr-2"
                />
              </router-link>

              <Button
                icon="pi pi-trash"
                class="p-button-rounded p-button-warning"
                @click="confirmDelete(slotProps.data)"
              />
            </template>
          </Column>
        </DataTable>

        <Dialog
          :visible.sync="create_dialog"
          :style="{ width: '450px' }"
          header="Tambah Kategori"
          :modal="true"
          class="p-fluid"
        >
          <div class="p-field">
            <label for="parent">Kelompok Kategori</label>
            <AutoComplete
              placeholder="Kelompok Kategori"
              :dropdown="true"
              :multiple="false"
              v-model="parent_selected"
              :suggestions="parent_categories"
              @complete="searchParentCategories($event)"
              field="name"
            />
          </div>
          <div class="p-field">
            <label for="code">Kode</label>
            <InputText
              class="form-control"
              :maxlength="3"
              v-model="create_data.code"
              placeholder="Kode"
              @keyup.prevent="is_error.code = false"
            />
            <small class="p-error" v-if="is_error.code">{{
              error_msg.code
            }}</small>
          </div>
          <div class="p-field">
            <label for="name">Nama</label>
            <InputText
              class="form-control"
              v-model="create_data.name"
              placeholder="Nama Kategori"
              @keyup.prevent="is_error.name = false"
            />
            <small class="p-error" v-if="is_error.name">{{
              error_msg.name
            }}</small>
          </div>

          <template #footer>
            <Button
              label="Batal"
              class="p-button-outlined"
              @click="create_dialog = false"
            />

            <!-- <Button
              label="Tambah"
              class="btn btn-primary"
              @click="postCategory"
            /> -->

            <Button
              type="button"
              label="Tambah"
              class="btn btn-primary"
              @click="postCategory()"
            >
              <span v-if="loading_tambah">
                <i class="pi pi-spin pi-spinner" style="font-size: 12px"></i>
              </span>
            </Button>
          </template>
        </Dialog>

        <Dialog
          :visible.sync="delete_dialog"
          :style="{ width: '450px' }"
          header="Konfirmasi Hapus"
          :modal="true"
        >
          <div class="confirmation-content">
            Apakah kamu yakin ingin menghapus <b>{{ delete_data.name }}</b
            >?
          </div>

          <template #footer>
            <Button
              label="Tidak"
              icon="pi pi-times"
              class="p-button-text"
              @click="delete_dialog = false"
            />
            <Button
              label="Ya"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteCategory()"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      create_dialog: false,
      delete_dialog: false,
      loading_tambah: false,
      loading: {
        filter: false,
        create: false
      },

      parent_categories: [],
      parent_selected: null,

      categories: [],

      create_data: {
        code: '',
        name: '',
        parent_id: 0
      },
      delete_data: {},

      filter: {
        code: '',
        name: ''
      },

      is_error: {
        name: false,
        code: false
      },
      error_msg: {
        kategori: '',
        name: '',
        code: ''
      }
    }
  },
  mounted() {
    this.getCategories()
  },
  methods: {
    getCategories() {
      this.loading.filter = true
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/dashboard/categories?code=${this.filter.code}&name=${this.filter.name}`
        )
        .then(response => {
          this.loading.filter = false
          if (response.status === 200) {
            this.categories = response.data.data.categories
          }
        })
    },

    searchParentCategories(event) {
      this.parent_categories = this.categories.filter(item => {
        return item.name.toLowerCase().startsWith(event.query.toLowerCase())
      })
    },

    createCategory() {
      this.create_dialog = true
      this.create_data.code = ''
      this.create_data.name = ''
      this.parent_selected = null
      this.is_error.name = false
      this.is_error.code = false
    },

    postCategory() {
      if (this.create_data.code == '') {
        this.is_error.code = true
        this.error_msg.code = 'Mohon isi kode'
      }
      if (this.create_data.name == '') {
        this.is_error.name = true
        this.error_msg.name = 'Mohon isi nama'
      } else {
        this.create_data.name = this.create_data.name.toUpperCase()
      }

      if (this.parent_selected != null) {
        this.create_data.parent_id = this.parent_selected.id
      }

      this.loading.create = true

      if (!this.is_error.code && !this.is_error.name) {
        this.loading_tambah = true
        this.$http
          .post(
            `${process.env.VUE_APP_API_URL}/dashboard/categories`,
            this.create_data
          )
          .then(response => {
            this.loading.create = false
            if (response.status === 200) {
              this.create_dialog = false
              this.getCategories()

              this.parent_selected = null
              this.create_data.parent_id = 0
              this.create_data.name = ''
              this.create_data.code = ''

              this.$toast.add({
                severity: 'success',
                summary: 'Berhasil Menambah Kategori',
                detail: 'Kategori berhasil ditambahkan',
                life: 3000
              })
              this.loading_tambah = false
            } else {
              this.$toast.add({
                severity: 'error',
                summary: 'Gagal Menambah Kategori',
                detail: 'Kode harus unik',
                life: 3000
              })
              this.loading_tambah = false
            }
          })
      }
    },

    confirmDelete(category) {
      Object.assign(this.delete_data, category)
      this.delete_dialog = true
    },

    deleteCategory() {
      this.$http
        .delete(
          `${process.env.VUE_APP_API_URL}/dashboard/categories/${this.delete_data.id}`
        )
        .then(response => {
          this.delete_dialog = false

          if (response.status === 200) {
            this.getCategories()

            this.$toast.add({
              severity: 'success',
              summary: 'Berhasil Menghapus Kategori',
              detail: 'Kategori berhasil di hapus',
              life: 3000
            })
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Gagal Menghapus Kategori',
              detail: 'Kategori gagal dihapus',
              life: 3000
            })
          }
        })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep(.p-datatable table) {
  border-collapse: collapse;
}

::v-deep(.p-datatable th),
::v-deep(.p-datatable td) {
  border: 1px solid #ccc !important;
  padding: 8px;
}
</style>
